<template>
  <div>
    <!-- <p class="font-weight-bold">
      <ConsoleLink to="/formula-variable" class="text-primary">
        {{ $t('sideBar.formula_variable') }} >
      </ConsoleLink> Edit {{ $t('sideBar.formula_variable') }}
    </p> -->

    <a-breadcrumb separator=">">
      <a-breadcrumb-item>
        <ConsoleLink to="/formula-variable" class="text-primary">
          {{ $t('sideBar.formula_variable') }}
        </ConsoleLink>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('utils.edit') }} {{ $t('sideBar.formula_variable') }}
      </a-breadcrumb-item>
    </a-breadcrumb>

    <EditFormulaVariable :permission="permission" />
  </div>
</template>

<script>
import EditFormulaVariable from '@/components/Price/Formula-Variable/Edit'
import ConsoleLink from '@/components/ConsoleLink/ConsoleLink.vue'

export default {
  components: {
    EditFormulaVariable,
    ConsoleLink,
  },
  computed: {
    permission() {
      return this.$store.getters['user/can']('formula-variable')
    },
  },
  // watch: {
  //   permission(newValue) {
  //     if(!newValue.length || !newValue.includes('WRITE')) {
  //       this.$router.push({path: '/error/403', query: {...this.$route.query}})
  //     }
  //   },
  // },
}
</script>
